import { Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, Inject, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { AppService } from '../../services/app.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../../services/data.service';
import { DateTimeFormatService } from '../../services/datetime-format.service';
import { Router } from '@angular/router';
import { LoadingService } from '../../services/loading.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceScannerComponent } from '../../customComponents/deviceScanner/deviceScanner.component';
import { EventEmitter } from '@angular/core';
import { EnumService } from '../../services/enum.service';
import { DeviceEnums } from '../../classes/deviceEnums';

@Component({
  templateUrl: './scanDevice.component.html',
})

export class ScanDeviceComponent {

  public optionSelected: number;
  private buttonLabel: string;
  public form!: FormGroup;
  public filteredPatientData: any = null;
  scannedDeviceGroups: [];
  constructor(private dataService: DataService, public appService: AppService, public enumService: EnumService, private _dateTimeService: DateTimeFormatService, private fb: FormBuilder
    , private router: Router, public dialog: MatDialog) {

  }

  loadFields(optionSelected) {
    this.filteredPatientData = null;
    //this.setModal(null);
    this.form = this.fb.group({});
    switch (optionSelected) {
      case 'patientOnECMO':
        this.buttonLabel = 'Find patient'
        this.optionSelected = 1;
        this.form.addControl('ScanOption', new FormControl(this.optionSelected));
        //this.form.addControl('Sex', new FormControl(null, Validators.required));
        //this.form.addControl('BirthDate', new FormControl(null, Validators.required));
        //this.form.addControl('TimeOn', new FormControl(null, Validators.required));
        //this.form.addControl('TimeOff', new FormControl(null, Validators.required));
        this.form.addControl('PatientUniqueId', new FormControl(null, Validators.required));
        this.form.addControl('TimeOn', new FormControl(null, Validators.required));
        //this.form.addControl('RunNo', new FormControl(1, Validators.required));
        break;
      case 'deviceFutureUse':
        this.optionSelected = 2;
        this.form.addControl('ScanOption', new FormControl(this.optionSelected));
        this.form.addControl('DeviceScanSetName', new FormControl(null, Validators.required));
        this.openScanner();
        break;
    }
  }

  findPatient() {
    this.dataService.update('DeviceScan/FindPatient', this.form.getRawValue()).subscribe(
      (res: any) => {
        if (res.data != null) {
          this.filteredPatientData = res.data;
        } else {
          alert('No patient mathching filter.')
        }
      },
      err => {
        console.log(err);
      }
    )
  }

  openScanner() {
    this.setModal(this.filteredPatientData);
  }

  setModal(patientFilter) {
    let dialogRef = this.dialog.open(ScanDeviceDialog, {
      panelClass: 'modal-scanner-template', // class to style your dialog
      data: {
        patientFilter: patientFilter,
        deviceScanSetName: this.form.controls['DeviceScanSetName'] != undefined ? this.form.controls['DeviceScanSetName'].value : null,
        scanOptionSelected: this.form.controls['ScanOption'].value,
        scannedDeviceGroups: this.scannedDeviceGroups,
        title: 'Device scaner',
        component: DeviceScannerComponent, //--> here component to load
      },
      maxWidth: '100%', // Optional: maximum width for larger screens
      minWidth: '70%',  // Optional: maximum height for larger screens
      minHeight: '50%',
      height: '800px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.dialogOption == 'yes') {
          console.log(result);
          //if (result.scannedDevices.length > 0) {
          if (this.optionSelected == 1) {
            for(var i = 0;  i <= result.scannedDevices.length - 1; i++){
              result.scannedDevices[i].PatientUniqueId = this.filteredPatientData.UniqueId;
              result.scannedDevices[i].TimeOn = this.filteredPatientData.TimeOn;
            }

            this.dataService.create('DeviceScan/CreateScannedDevicesForPatient', result.scannedDevices).subscribe(
              (res: any) => {
              },
              err => {
                console.log(err);
              }
            );

            //} else {
            //  this.dataService.create('DeviceScan/CreateScannedDevices', result.scannedDevices).subscribe(
            //    (res: any) => {
            //    },
            //    err => {
            //      console.log(err);
            //    }
            //  );
            //}
          }

          //if (result.scanOptionSelected == 2) {
          //  this.getPreScannedDevices();
          //}
        }
      }
    });
  }

  ngOnInit() {
    if (!this.enumService.DeviceEnums) {
      this.enumService.DeviceEnums = new DeviceEnums();
    }
    this.getPreScannedDevices();

    this.getAllManufacturers();
  }

  getAllManufacturers() {
    this.dataService.getall('Enums/GetEquipmentAllManufacturers').subscribe(
      (res: any) => {
        this.enumService.DeviceEnums.enumAllManufacturers = res.data;
      },
      err => {
        console.log(err);
      }
    )
  }
  getPreScannedDevices() {
    this.dataService.getall('DeviceScan/GetScannedDeviceGroups').subscribe(
      (res: any) => {
        this.scannedDeviceGroups = res.data;
      },
      err => {
        console.log(err);
      }
    );
  }
 }



@Component({
  selector: 'dialog-scandevice',
  templateUrl: 'scanDeviceDialog.html',
})
export class ScanDeviceDialog {

  @ViewChild('dynamicComponent', { read: ViewContainerRef }) container;
  componentRef: ComponentRef<any>
  hostedComponent = null;
  public form!: FormGroup;
  filteredPatients: any;
  hostedComponentSubs: any;
  scannedDevices = [];
  selectedPatient = null;
  selectedRun = null;
  public scanOptionSelected = null;
  deviceScanSetName = null;
  scannedDeviceGroups = [];
  showDeviceTypeOptionAndButton = false;
  tempScannedGudid = null;
  constructor(public dialogRef: MatDialogRef<ScanDeviceDialog>, @Inject(MAT_DIALOG_DATA) public data: any, public appService: AppService
    , public enumService: EnumService, private fb: FormBuilder, private dataService: DataService
    , private resolver: ComponentFactoryResolver) {
  }


  ngOnInit() {
    this.form = this.fb.group({});

    this.showDeviceTypeOptionAndButton = false;

    this.scanOptionSelected = this.data.scanOptionSelected;
    this.deviceScanSetName = this.data.deviceScanSetName;
    this.scannedDeviceGroups = this.data.scannedDeviceGroups;

    this.form.addControl('DeviceType', new FormControl(null));
    //this.form.addControl('ManufacturerId', new FormControl(null));
    //this.form.addControl('DeviceName', new FormControl(null));
    //this.form.addControl('Model', new FormControl(null));

    setTimeout(() => {//Timeout is required for container to be defined
      this.createComponent();
    }, 0);
    
  }

  confirmDialogOption(dialogOption: string): void {
    var dialogResult = {
      strNextOrBack: this.data.strNextOrBack,
      dialogOption: dialogOption,
      scannedDevices: this.scannedDevices,
      scanOptionSelected: this.scanOptionSelected
      // createEdit: this.data.createEdit
    };

    this.dialogRef.close(dialogResult);

  }

  createComponent() {
    this.container.clear();
    const factory: ComponentFactory<any> = this.resolver.resolveComponentFactory(this.data.component);
    this.componentRef = this.container.createComponent(factory);
    //const hostedComponent = this.componentRef.instance;
    this.hostedComponent = this.componentRef.instance;

    //////////////// Pass through outputs from hosted component//////////////////
    Object.keys(this.hostedComponent)
      .filter(prop => this.hostedComponent[prop] instanceof EventEmitter)
      .forEach(output => {
        this[output] = new EventEmitter()
        this[`${output}_sub`] = this.hostedComponent[output].subscribe(data => {
          this[output].emit(data)
        })
      });
    //used to receive data from child component that is hosted in material dialog/modal. This wont work without code above
    this.dialogRef.afterOpened()
      .subscribe(() => {
        this.hostedComponentSubs = this.dialogRef.componentInstance['barCodeScanned'].subscribe((event) => { this.attachScannedDevice(event); });
      });
    ////////////////
    this.hostedComponent.disabled = false;
    //unsubscribe everything after dialog is closed
    this.dialogRef.afterClosed().subscribe(() => this.hostedComponentSubs.unsubscribe())
  }

  attachScannedDevice(scannedDevice, preScanned?) {
    this.form.controls['DeviceType'].setValue(null);
    this.showDeviceTypeOptionAndButton = false;
    this.tempScannedGudid = null;

    //console.log(scannedDevice);
    if (this.scannedDevices.length > 0) {
      if (this.appService.lodashFindBy(this.scannedDevices, 'DeviceGudidId', scannedDevice.scannedCode)) {
        var confirmed = confirm('Scanned device is already added. Add another device with same code?');
        if (confirmed != true) {
          return;
        }
      }
    }

    //search for device gudid in database
    this.dataService.get('DeviceScan/GetScanedDeviceLookup', 'DeviceGudidId', scannedDevice.scannedCode).subscribe(
      (res: any) => {
        console.log(res);

        if (res.data) {
          //device present and maybe matched in database, dont ask for device type
          this.form.controls['DeviceType'].setValue(res.data.DeviceType);
          this.addScannedDeviceToArray(scannedDevice.scannedCode);
        } else {
          //device not present, ask for device type
          this.showDeviceTypeOptionAndButton = true;
          this.tempScannedGudid = scannedDevice.scannedCode;
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  addScannedDeviceToArray(scannedCode) {
    this.scannedDevices.push(
      {
        TempId: this.appService.generateUUID(),
        DeviceScanId: 0,
        DeviceGudidId: scannedCode,
        //DeviceManufacturer: this.form.controls['ManufacturerId'].value,
        //DeviceName: this.form.controls['DeviceName'].value,
        //DeviceModelNumber: this.form.controls['Model'].value,
        DeviceType: this.form.controls['DeviceType'].value,
      }
    );
    console.log(this.scannedDevices);
  }

  isStringBlank(str) {
    return (!str || /^\s*$/.test(str));
  }

  public assignTypeToDevice() {
    this.addScannedDeviceToArray(this.tempScannedGudid);
  }

  //public deviceFieldsSelectionChange() {
  //  if (this.form.controls['DeviceType'].value == null || this.form.controls['ManufacturerId'].value == null || !this.form.controls['DeviceName'].value) {
  //    this.hostedComponent.disabled = true; //disable scanner button
  //  } else {
  //    if (!this.isStringBlank(this.form.controls['DeviceName'].value)) {
  //      this.hostedComponent.disabled = false; //enable scanner button
  //    } else {
  //      this.hostedComponent.disabled = true; //disable scanner button
  //    }
  //  }
  //}

  deleteScannedDevice(scannedDevice) {
    this.appService.lodashRemoveBy(this.scannedDevices, 'TempId', scannedDevice.TempId);
  }

  addPreScannedDevice() {
    console.log(this.appService.lodashFindBy(this.scannedDeviceGroups, 'DeviceGudidId', this.form.controls['PreScannedDevice'].value));
    this.attachScannedDevice({ scannedCode: this.form.controls['PreScannedDevice'].value, deviceType: this.appService.lodashFindBy(this.scannedDeviceGroups, 'DeviceGudidId', this.form.controls['PreScannedDevice'].value).DeviceType }, true);
  }
}

